import React from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const EditionButtons = ({
    canUpdatePreview,
    editionDisabled,
    handleClickCancel,
    handleClickSave,
    isUpdatingCustomTemplate,
}) => {
    const { t } = useTranslation();
    return (
        <Grid container sx={{ mb: 1 }}>
            <Grid
                size={{ xs: 'grow' }}
                sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
            >
                {canUpdatePreview && !editionDisabled && (
                    <Button
                        fullWidth
                        onClick={() => handleClickSave()}
                        type="button"
                        variant="outlined"
                    >
                        {isUpdatingCustomTemplate ? t('Saving') : t('Save')}
                    </Button>
                )}

                {!editionDisabled && (
                    <Button
                        color="secondary"
                        fullWidth
                        onClick={() => handleClickCancel()}
                        type="button"
                        variant="text"
                    >
                        {t('Cancel')}
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};

EditionButtons.propTypes = {
    canUpdatePreview: PropTypes.bool,
    editionDisabled: PropTypes.bool,
    handleClickCancel: PropTypes.func,
    handleClickSave: PropTypes.func,
    isUpdatingCustomTemplate: PropTypes.bool,
};

export default EditionButtons;
